import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useApp } from '../context/AppContext';

/**
 * AbsoluteReaderPage:
 * Dedicated reader for 'absolute_html' books.
 * Renders the new reader.html with full toolbar, S3 streaming, download progress, and DOM virtualization.
 */
const AbsoluteReaderPage = ({ book, onBack }) => {
  const { getToken } = useApp();
  const [token, setToken] = useState('');
  const iframeRef = useRef(null);

  useEffect(() => {
    getToken().then(t => setToken(t || localStorage.getItem('air_access_token') || '')).catch(() => {});
  }, [getToken]);

  useEffect(() => {
    // Expose global perf() and checkPerformance() directly on top React window
    window.perf = window.checkPerformance = function () {
      try {
        const frame = iframeRef.current;
        if (frame && frame.contentWindow) {
          if (typeof frame.contentWindow.perf === 'function') {
            return frame.contentWindow.perf();
          }
        }
      } catch (_) {}
      console.warn('[AIR-PERF] Reader frame is still loading or initializing virtualization.');
    };

    return () => {
      delete window.perf;
      delete window.checkPerformance;
    };
  }, []);

  const bookId = book?._id || book?.id;
  const bookName = book?.book_name || book?.name || 'AIR E-Book';

  const readerUrl = useMemo(() => {
    return `/reader.html?book=${bookId}&name=${encodeURIComponent(bookName)}`;
  }, [bookId, bookName]);

  return (
    <div style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', zIndex: 99999, background: '#FDFAF7', display: 'flex', flexDirection: 'column' }}>
      <iframe
        ref={iframeRef}
        src={readerUrl}
        title={bookName}
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        allow="fullscreen; clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default AbsoluteReaderPage;